<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="产品编码" prop="fiveBitCode">
                    <el-input v-model="queryCondition.fiveBitCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品中文名称" prop="describe">
                    <el-input v-model="queryCondition.describe" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品英文名称" prop="fiveBitCodeName">
                    <el-input v-model="queryCondition.fiveBitCodeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="categoryLevel2CodeList">
                    <el-select v-model="queryCondition.categoryLevel2CodeList" @change="changeCategory2" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                      <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Category3" prop="categoryLevel3CodeList">
                      <el-select v-model="queryCondition.categoryLevel3CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                        <el-option v-for="item in categoryList3" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="结算单位名称" prop="supplierName">
                      <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="工厂名称" prop="facilityName">
                      <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <ic-select table="TT_NUTR_INGREDIENT" field="STATUS" clearable v-model="queryCondition.status" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="最新检测日期从" prop="lastInspectDateBegin">
                      <el-date-picker v-model="queryCondition.lastInspectDateBegin" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="最新检测日期至" prop="lastInspectDateEnd">
                      <el-date-picker v-model="queryCondition.lastInspectDateEnd" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="烹饪方式" prop="cookCode">
                      <ic-select table="TR_NUTR_GRI_COOK" field="COOK_CODE" clearable v-model="queryCondition.cookCode" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="检测标识" prop="needInspect">
                      <ic-select table="TT_NUTR_INGREDIENT" field="NEED_INSPECT" clearable v-model="queryCondition.needInspect" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onUpdate" v-acl="NEED_INSPECT_UPDATE">更新检测标识</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onLabUpdate" v-acl="INSPECT_LAB_UPDATE">更新检测实验室</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onDownload" v-acl="INGREDIENT_EXPORT">导出</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="fiveBitCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'fiveBitCode')" show-overflow-tooltip label="产品编码" width="130">
            <template slot-scope="scope">
              <el-button @click="goPage(scope.row)" type="text" size="small" v-if="isGo">{{scope.row.fiveBitCode}}</el-button>
              <span v-else>{{scope.row.fiveBitCode}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="describe" sortable :sort-method="(a,b) => sortMethods(a ,b , 'describe')" show-overflow-tooltip label="产品中文名称" width="150"></el-table-column>
          <el-table-column prop="fiveBitCodeName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'fiveBitCodeName')" show-overflow-tooltip label="产品英文名称" width="150"></el-table-column>
          <el-table-column prop="supplierName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'supplierName')" show-overflow-tooltip label="结算单位名称" width="150"></el-table-column>
          <el-table-column prop="facilityName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'facilityName')" show-overflow-tooltip label="工厂名称" width="150"></el-table-column>
          <el-table-column prop="categoryLevel2Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryLevel2Name')" show-overflow-tooltip label="Category2" width="120"></el-table-column>
          <el-table-column prop="categoryLevel3Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryLevel3Name')" show-overflow-tooltip label="Category3" width="120"></el-table-column>
          <el-table-column prop="cookCodeText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'cookCodeText')" show-overflow-tooltip label="烹饪方式" width="120"></el-table-column>
          <el-table-column prop="statusText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'statusText')" show-overflow-tooltip label="状态" width="90"></el-table-column>
          <el-table-column prop="needInspectText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'needInspectText')" show-overflow-tooltip label="检测标识" width="120"></el-table-column>
          <el-table-column prop="adjustReason" sortable :sort-method="(a,b) => sortMethods(a ,b , 'adjustReason')" show-overflow-tooltip label="修改原因" width="180"></el-table-column>
          <el-table-column prop="lastInspectDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'lastInspectDate')" show-overflow-tooltip label="最新检测日期" width="150"></el-table-column>
          <el-table-column prop="inspectLabCodeText" sortable :sort-method="(a,b) => sortMethods(a ,b , 'inspectLabCodeText')" show-overflow-tooltip label="检测实验室" width="180"></el-table-column>
          <el-table-column prop="remark" sortable :sort-method="(a,b) => sortMethods(a ,b , 'remark')" show-overflow-tooltip label="备注" width="180"></el-table-column>
          <!-- :sort-method="sortMethods" -->
          <el-table-column prop="updateDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" show-overflow-tooltip label="更新日期" width="150"></el-table-column>
          <el-table-column prop="updateByName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateByName')" show-overflow-tooltip label="更新人" width="150"></el-table-column>
          <el-table-column prop="createDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'createDate')" show-overflow-tooltip label="创建日期" width="150"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="onRemark(scope.row)" type="text" size="small" v-acl="INGREDIENT_COMMENTS">备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
      <el-dialog title="更新检测标识" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="onClose">
        <el-form ref="testForm" :model="testForm" :rules="testFormRules" label-width="100px">
          <el-form-item label="检测标识" prop="needInspect">
            <ic-select table="TT_NUTR_INGREDIENT" field="NEED_INSPECT" clearable v-model="testForm.needInspect" style="width:100%"></ic-select>
          </el-form-item>
          <el-form-item label="修改原因" prop="adjustReason">
            <el-input v-model="testForm.adjustReason" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveTest" :disabled="isSaveDisabled1" :loading="isSaveLoading1">保存</el-button>
          <el-button size="mini" class="btn" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="检测实验室维护" :visible.sync="dialogVisible1" width="30%" :close-on-click-modal="false" @close="onCloseMain">
        <el-form ref="maintenanceForm" :model="maintenanceForm" :rules="labRules" label-width="100px">
          <el-form-item label="检测实验室" prop="inspectLabCode">
            <ic-select table="TM_USER" field="LABORATORY" clearable v-model="maintenanceForm.inspectLabCode" style="width:100%"></ic-select>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveLab" :disabled="isSaveDisabled2" :loading="isSaveLoading2">保存</el-button>
          <el-button size="mini" class="btn" @click="onCloseMain">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="备注" :visible.sync="dialogNoteVisible" width="30%" :close-on-click-modal="false" @close="onCloseNote">
        <el-form ref="noteForm" :model="noteForm" :rules="rules" label-width="80px">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="noteForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveNote" :disabled="isSaveDisabled3" :loading="isSaveLoading3">保存</el-button>
          <el-button size="mini" class="btn" @click="onCloseNote">关闭</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils";
import Sortable from "sortablejs";
import IcSelect from "@/components/common/icSelect";
export default {
  // name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect },
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: "",
        fiveBitCodeName: "",
        describe: "",
        categoryLevel2CodeList: [],
        categoryLevel3CodeList: [],
        supplierName: "",
        facilityName: "",
        status: "Enable",
        lastInspectDateBegin: "",
        lastInspectDateEnd: "",
        needInspect: "",
        cookCode:"",
      },
      totalCount: 0,
      pages: 1,
      isShow: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogNoteVisible: false,
      isSaveDisabled1: false,
      isSaveLoading1: false,
      isSaveDisabled2: false,
      isSaveLoading2: false,
      isSaveDisabled3: false,
      isSaveLoading3: false,
      isGo: true,
      tableData: [],
      testForm: {
        needInspect: "",
        adjustReason: "",
        ingredientIdList: []
      },
      testFormRules: {
        needInspect: [
          { required: true, message: '请选择检测标识', trigger: 'change' }
        ],
        adjustReason: [
          { required: true, message: '请输入修改原因', trigger: 'blur' }
        ]
      },
      labRules: {
        inspectLabCode: [
          { required: true, message: '请选择检测实验室', trigger: 'change' }
        ],
      },
      categoryList2: [],
      categoryList3: [],
      multipleSelection: [],
      ingredientIdList: [],
      noteForm: {
        remark: "",
      },
      maintenanceForm: {
        inspectLabCode: "",
        ingredientIdList: []
      },
      rules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
      },
      ingredientId: null,
      oldData: [],
      proptype: ''
    };
  },
  // watch: {
  //   queryCondition() {
  //     let _this = this;
  //     store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  // QIPApi.findListPage(to.meta.reqData).then((res) => {
  //   next(vm => {
  //     vm.queryCondition = to.meta.reqData;
  //     vm.tableData = res.data.records;
  //     vm.totalCount = res.data.total;
  //   })
  // })
  // },
  mounted() {
    this.queryData()
    this.getCategory1()
    console.log('ms_Permission', localStorage.getItem('ms_Permission'))
    if (JSON.parse(localStorage.getItem('ms_Permission').indexOf('1902') !== -1)) {
      this.isGo = true
    } else {
      this.isGo = false
    }
  },
  methods: {
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
        var pid
        res.data.forEach(ele => {
          if (ele.code == '10' && ele.name == 'Food') {
            pid = ele.tmCategoryId
          }
        })
        this.getCategory2(pid)
      });
    },
    getCategory2(pid) {
      apiService.findCategory({ categoryLevel: 2, pid: pid }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:507 ~ apiService.findCategory ~ res:", res)
        this.categoryList2 = res.data;
      });
    },
    changeCategory2() {
      this.categoryList3 = []
      var category2Codes = []
      this.categoryList2.forEach(ele => {
        if (this.queryCondition.categoryLevel2CodeList.includes(ele.code)) {
          category2Codes.push(ele.tmCategoryId)
        }
      })
      apiService.findCategory({ categoryLevel: 3, pidList: category2Codes }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:515 ~ apiService.findCategory ~ res:", res)
        this.categoryList3 = res.data;
      });
    },
    queryData() {
      delete this.queryCondition.ingredientIdList
      nutriApi.findIngredientListPage(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: ingredient.vue:256 ~ nutriApi.findIngredientListPage ~ res:", res)
        this.tableData = res.resultData;
        this.totalCount = res.totalCount
      });
    },
    goPage(row) {
      this.$router.push({
        path: "/materialGRI",
        query: {
          fiveBitCode: row.fiveBitCode
        }
      })
    },
    onUpdate() {
      if (this.ingredientIdList.length === 0) {
        this.$message.error('请至少勾选一条数据!')
        return
      }
      var isFlag = this.multipleSelection.every(ele => {
        return ele.status === 'Enable'
      })
      if (!isFlag) {
        this.$message.error('存在状态为禁用的数据，无法修改.')
        return
      }
      this.dialogVisible = true
    },
    onSaveTest() {
      this.$refs['testForm'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled1 = true
          this.isSaveLoading1 = true
          nutriApi.saveInspectFlag({
            adjustReason: this.testForm.adjustReason,
            ingredientIdList: this.ingredientIdList,
            needInspect: this.testForm.needInspect
          }).then((res) => {
            console.log("🚀 ~ file: ingredient.vue:302 ~ this.$refs['testForm'].validate ~ res:", res)
            this.isSaveDisabled1 = false
            this.isSaveLoading1 = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.onClose()
              this.queryData()
            }
          }).catch(error => {
            console.log("🚀 ~ file: ingredient.vue:357 ~ this.$refs['testForm'].validate ~ error:", error.response)
            this.isSaveDisabled1 = false
            this.isSaveLoading1 = false
          })
        }
      })
    },
    onLabUpdate() {
      if (this.ingredientIdList.length === 0) {
        this.$message.error('请至少勾选一条数据!')
        return
      }
      this.dialogVisible1 = true
    },
    onSaveLab() {
      this.$refs['maintenanceForm'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled2 = true
          this.isSaveLoading2 = true
          nutriApi.saveLab({
            inspectLabCode: this.maintenanceForm.inspectLabCode,
            ingredientIdList: this.ingredientIdList,
          }).then((res) => {
            console.log("🚀 ~ file: ingredient.vue:336 ~ this.$refs['maintenanceForm'].validate ~ res:", res)
            this.isSaveDisabled2 = false
            this.isSaveLoading2 = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.onCloseMain()
              this.queryData()
            }
          });
        }
      })
    },
    onRemark(row) {
      this.dialogNoteVisible = true
      this.ingredientId = row.ingredientId

    },
    onSaveNote() {
      this.$refs['noteForm'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled3 = true
          this.isSaveLoading3 = true
          nutriApi.saveNote({
            ingredientId: this.ingredientId,
            remark: this.noteForm.remark
          }).then((res) => {
            console.log("🚀 ~ file: ingredient.vue:358 ~ nutriApi.saveNote ~ res:", res)
            this.isSaveDisabled3 = false
            this.isSaveLoading3 = false
            if (res.code === '200') {
              this.$message.success('保存成功')
              this.onCloseNote()
              this.queryData()
            }
          });
        }
      })
    },
    onDownload() {
      this.$set(this.queryCondition, 'ingredientIdList', this.ingredientIdList)
      nutriApi.downloadIngredientLists(this.queryCondition).then(res => {
        console.log("🚀 ~ file: nutritionDetection.vue:731 ~ nutriApi.downloadAttachmentTemplate ~ res:", res)
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.ingredientIdList = []
      val.forEach(ele => {
        this.ingredientIdList.push(ele.ingredientId)
      })
      console.log("🚀 ~ file: ingredient.vue:322 ~ handleSelectionChange ~ this.ingredientIdList:", this.ingredientIdList)
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'lastInspectDate') {
        prop = 'lastInspectDateMiss'
      } else if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      } else if (proptype === 'createDate') {
        prop = 'createDateMiss'
      } else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: "",
        fiveBitCodeName: "",
        describe: "",
        categoryLevel2Code: "",
        categoryLevel3Code: "",
        supplierName: "",
        facilityName: "",
        status: "Enable",
        lastInspectDateBegin: "",
        lastInspectDateEnd: "",
        needInspect: "",
        cookCode:"",
      }
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onClose() {
      this.dialogVisible = false
      this.$refs['testForm'].resetFields();
      this.testForm = {
        needInspect: "",
        adjustReason: "",
        ingredientIdList: []
      }
    },
    onCloseMain() {
      this.dialogVisible1 = false
      this.$refs['maintenanceForm'].resetFields();
      this.testForm = {
        inspectLabCode: "",
        ingredientIdList: []
      }
    },
    onCloseNote() {
      this.dialogNoteVisible = false
      this.$refs['noteForm'].resetFields();
      this.noteForm = {
        remark: "",
      }
    },
  }
}
</script>
  